export const HostBackend = () => {
    const protocol = window.location.protocol;
    const host = window.location.hostname;
    const hostBackend = `${protocol}//${host}/backend`
    return hostBackend;
}